import React from "react";
import { AnomaliesPartnerSettlementApi } from "../../../../../../../../../../services/Api/Admin/adminTypes";

interface Props {
	anomaliesPartnerSettlements: AnomaliesPartnerSettlementApi[];
}

const AdminToolsAnomaliesPartnerSettlements = ({ anomaliesPartnerSettlements }: Props) => {
	return (
		<table className="table w-100">
			<thead>
				<tr>
					<td>#</td>
					<td>Typ obiektu</td>
					<td>ID obiektu</td>
					<td>Nazwa obiektu</td>
					<td>Rodzaj błędu</td>
					<td>Priorytet</td>
					<td>Szczegóły błędu</td>
				</tr>
			</thead>
			{anomaliesPartnerSettlements.map((anomaliesPartnerSettlement, index) => {
				return (
					<tr key={index}>
						<td>{index}</td>
						<td>{anomaliesPartnerSettlement.type}</td>
						<td>{anomaliesPartnerSettlement.id}</td>
						<td>{anomaliesPartnerSettlement.name}</td>
						<td>{anomaliesPartnerSettlement.anomaly_type}</td>
						<td>{anomaliesPartnerSettlement.priority}</td>
						<td>{anomaliesPartnerSettlement.description}</td>
					</tr>
				);
			})}
		</table>
	);
};

export default AdminToolsAnomaliesPartnerSettlements;
